import { useMemo } from 'react';

const useFilteredProviders = (providers: any[], doctorId?: any | null) => {
    const filteredProvider = useMemo(() => {
        if (!doctorId || doctorId === undefined) {
            // If doctorId is undefined, return the first provider or undefined
            return null;
        }

        // Convert the doctorId to a string format for comparison
        const doctorIdString = doctorId.toString();

        // Find the first provider that matches the provided doctor ID
        const matchedProvider = providers.find(provider => {
            // Assuming the provider has an id field that should be matched with doctorId
            const providerId = provider.id.toString();
            return providerId === doctorIdString;
        });

        return matchedProvider;
    }, [providers, doctorId]);

    return filteredProvider;
};

export default useFilteredProviders;
